import styled from 'styled-components';

type PortfolioSecondaryHeaderLeftContainerProps = {
  isMobileDevice: boolean;
};

export const PortfolioSecondaryHeaderLeftContainer = styled.div<PortfolioSecondaryHeaderLeftContainerProps>`
  display: flex;
  column-gap: 10px;

  ${(props) =>
    props.isMobileDevice
      ? `padding: 9px 13px 9px 0px;
          background-color: white;  
          width: 100%;
          justify-content: space-between;`
      : ''}
`;
